module.exports = __webpack_public_path__ + "static/media/Flaticon.b3459d5a.eot";